module.exports = __webpack_public_path__ + "media/images/logo-143b08c1c59823fc4d19b2496424e768.png";